import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLineColumns,
  faQuestion,
  faAbacus,
  faSortAlphaDown,
  faSortAmountDownAlt,
  faGlobeStand,
  faFilter,
  faLayerPlus,
  faLayerGroup,
  faSendBack,
  faBringFront,
  faFunction,
  faIntersection,
  faUnion,
  faLockAlt,
  faObjectGroup,
  faRedo,
  faSdCard,
  faLocation,
  faArrowSquareUp,
  faArrowToTop,
  faArrowUp,
  faPollH,
  faEdit,
  faCalculatorAlt,
  faExpandArrowsAlt,
  faLevelDown,
  faColumns,
  faCogs,
  faContainerStorage,
  faCabinetFiling,
  faCompressWide,
  faFilm,
  faGripVertical,
  faInventory,
  faPuzzlePiece,
  faGameBoard,
  faGameBoardAlt,
  faBallotCheck,
  IconDefinition,
  faArchive,
  faBrain,
} from "@fortawesome/pro-light-svg-icons";

function NodeTypeIcon({
  nodeType,
  className,
}: {
  nodeType: string;
  className?: string;
}) {
  return (
    <FontAwesomeIcon className={className} icon={getIconDefinition(nodeType)} />
  );
}

function getIconDefinition(nodeType: string): IconDefinition {
  switch (nodeType) {
    case "Seq Scan":
      return faLineColumns;
    case "Aggregate":
      return faAbacus;
    case "Sort":
      return faSortAlphaDown;
    case "Incremental Sort":
      return faSortAmountDownAlt;
    case "Limit":
      return faFilter;
    case "Foreign Scan":
      return faGlobeStand;
    case "Append":
      return faLayerPlus;
    case "Merge Append":
      return faLayerGroup;
    case "Gather Merge":
      return faSendBack;
    case "Gather":
      return faBringFront;
    case "Function Scan":
      return faFunction;
    case "Table Function Scan":
      return faFunction;
    case "BitmapAnd":
      return faIntersection;
    case "BitmapOr":
      return faUnion;
    case "LockRows":
      return faLockAlt;
    case "Group":
      return faObjectGroup;
    case "Nested Loop":
      return faRedo;
    case "Materialize":
      return faSdCard;
    case "Index Only Scan":
      return faLocation;
    case "Index Scan":
      return faArrowSquareUp;
    case "Bitmap Heap Scan":
      return faArrowToTop;
    case "Bitmap Index Scan":
      return faArrowUp;
    case "Result":
      return faPollH;
    case "ModifyTable":
      return faEdit;
    case "SetOp":
      return faCalculatorAlt;
    case "ProjectSet":
      return faExpandArrowsAlt;
    case "Recursive Union":
      return faLevelDown;
    case "Tid Scan":
      return faColumns;
    case "Tid Range Scan":
      return faColumns;
    case "Custom Scan":
      return faCogs;
    case "Values Scan":
      return faContainerStorage;
    case "WorkTable Scan":
      return faCabinetFiling;
    case "WindowAgg":
      return faCompressWide;
    case "Subquery Scan":
      return faFilm;
    case "CTE Scan":
      return faGripVertical;
    case "Sample Scan":
      return faInventory;
    case "Named Tuplestore Scan":
      return faArchive;
    case "Hash":
      return faPuzzlePiece;
    case "Hash Join":
      return faGameBoard;
    case "Merge Join":
      return faGameBoardAlt;
    case "Memoize":
      return faBrain;
    case "Unique":
      return faBallotCheck;
    default:
      return faQuestion;
  }
}

export default NodeTypeIcon;
